export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于90影视
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                90影视成立于2020年，是一家专注于高清影视内容聚合与分发的在线观影平台。
                我们致力于为广大影迷提供海量电影、电视剧、综艺、动漫等优质内容的一站式免费观看服务。
              </p>
              <p>
                平台汇聚超过<strong className="text-accent-600 font-semibold">10,000部</strong>精选影视资源，
                涵盖动作、喜剧、科幻、悬疑、爱情等多种类型，满足不同观众的观影需求。
                我们坚持<strong className="text-accent-600 font-semibold">每日更新50部以上</strong>新内容，
                确保用户始终能观看到最新最热的院线大片与卫视热播剧集。
              </p>
              <p>
                90影视采用先进的<strong className="text-accent-600 font-semibold">多线路智能分发技术</strong>，
                保障99.9%的影片流畅播放。同时，我们高度重视用户访问安全，所有页面均采用HTTPS加密传输，让您安心观影。
              </p>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20setup%20with%20soft%20amber%20lighting%2C%20large%20screen%20displaying%20abstract%20film%20visual%2C%20cozy%20atmosphere%2C%20popcorn%20and%20film%20reel%20decor%2C%20rich%20warm%20tones%2C%20no%20text%2C%20inviting%20entertainment%20scene%2C%20lifestyle%20photography&width=1000&height=750&seq=about-brand-01&orientation=landscape"
                alt="90影视品牌介绍 - 家庭影院观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}